<template>
  <b-form-radio-group class="comment-order" v-model="action.commentPosition">
    <label class="font-weight-bold" for="">{{
      $t('newAction.stepOne.labels.commentOrder')
    }}</label>
    <div class="ml-3">
      <b-form-radio class="row mr-4" value="down">
        {{ $t('newAction.stepOne.labels.afterAdditionalQuestion') }}
      </b-form-radio>
      <b-form-radio class="row" value="up">
        {{ $t('newAction.stepOne.labels.beforeAdditionalQuestion') }}
      </b-form-radio>
    </div>
  </b-form-radio-group>
</template>

<script>
import { mapFields } from 'vuex-map-fields';

export default {
  computed: {
    ...mapFields('actions', ['action']),
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/molecules/comment-area-position/index.vue